/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: utils/formDefaults.ts (Dial Rule Restrictions)
 🗓️ Created: 2025-01-27
 🧩 Description:
    Default values and factories for Dial Rule Restrictions forms.
────────────────────────────────────────────────────────────────*/

import { FormState, RuleFormState } from '../types';

const PRIORITY_STEP = 10;

/**
 * Create client ID for drag & drop
 */
export function createClientId(): string {
  return crypto.randomUUID?.() ?? `rule-${Date.now()}-${Math.random().toString(16).slice(2)}`;
}

/**
 * Create empty rule
 */
export function createEmptyRule(priority: number): RuleFormState {
  return {
    clientId: createClientId(),
    direction: 'outbound',
    pattern: '',
    allowed: false,
    announcement: null,
    playMaxDuration: false,
    maxDurationSeconds: null,
    requirePassword: false,
    priority,
    enabled: true,
  };
}

/**
 * Default form state
 */
export const DEFAULT_FORM_STATE: FormState = {
  name: '',
  description: '',
  enabled: true,
  rules: [],
};

/**
 * Get default form state
 */
export function getDefaultFormState(): FormState {
  return JSON.parse(JSON.stringify(DEFAULT_FORM_STATE));
}

/**
 * Clone form state
 */
export function cloneFormState(state: FormState): FormState {
  return {
    ...state,
    rules: state.rules.map((rule) => ({ ...rule })),
  };
}

